export const hasProp = <K extends PropertyKey>(e: unknown, prop: K): e is Record<K, unknown> =>
  !!e && Object.hasOwnProperty.call(e, prop);
